import cmp from './LabeledTextfield'

export default cmp
